import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.CatalogItemDetails'

export default defineMessages({
  collapseAriaLabel: {
    id: `${scope}.collapseAriaLabel`,
    defaultMessage: 'Collapse details panel',
  },
  sku: {
    id: `${scope}.sku`,
    defaultMessage: 'SKU: {sku}',
  },
  agentAnalysisTitle: {
    id: `${scope}.agentAnalysisTitle`,
    defaultMessage: 'Agent analysis',
  },
  catalogDetailsTitle: {
    id: `${scope}.catalogDetailsTitle`,
    defaultMessage: 'Catalog details',
  },
})
